<script lang="ts">
  import { appManager } from "../AppManager";

  async function signin() {
    const to = (await appManager.completeSignin()) || "/";

    window.location.href = to;
  }
</script>

{#await signin()}
  <div />
{/await}
